import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles(
  (theme) => ({
    dialogContainer: {
      padding: theme.spacing(2),
    },
    paper: {
      width: 772,
    },
    textContainer: {
      margin: theme.spacing(5, 0),
    },
    icon: {
      height: "40px",
      width: "40px",
    },
    centeredText: {
      textAlign: "center",
    },
    info50: {
      color: theme.palette.secondary.main,
    },
    subtitle: {
      marginTop: theme.spacing(0.5),
      padding: theme.spacing(0, 2),
    },
    closeModalButton: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(2),
    },
    reminderInformation: {
      paddingLeft: theme.spacing(3),
    },
  }),
  { index: 10 }
);
